import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import { Colors } from '../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: 12,
    color: Colors.Blue2,
  },
  icon: {
    fontSize: '50px !important',
    color: Colors.Blue2,
  },
  label: {
    fontSize: 10,
    fontWeight: 400,
    '& span': {
      color: Colors.Blue2,
      marginLeft: 20,
    },
  },
}));

export default useStyles;